import { render, staticRenderFns } from "./RightsButtons.vue?vue&type=template&id=5d29929b&scoped=true"
import script from "./RightsButtons.vue?vue&type=script&lang=js"
export * from "./RightsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29929b",
  null
  
)

export default component.exports